{
    "LogFileDownload_DownloadTitle": "Herunterladen **{}**",
    "LogFileDownload_HowManyFiles": "Wie viele vorherige Dateien möchten Sie herunterladen?",
    "LogFileDownload_AllFiles": "Alle Dateien",
    "LogFileDownload_NFile": "Vergangene {} Datei(en)",
    "LogFileDownload_CurrentFile": "Aktuelle Datei",
    "NAME": "LanguageLogFileDownload"
}